/* eslint-disable */
import React, { Component } from 'react';

import Classes  from './ConfigBanned.css'
import Aux      from './../../hoc/Aux';
import logger   from './../../logger';
import MConfig  from './../../moramma-config.json';
import ConfigBannedItem from './ConfigBannedItem/ConfigBannedItem';

class ConfigBanned extends Component{

    state = {
        isSettingsFetched : false,
        settings : {}
    }

    componentDidMount = () => {

        logger.debug(`[ConfigBanned|componentDidMount] Fetching data from api.moramma`);

        // fetch actual config file
        fetch(MConfig["API_GET_SETTINGS"])
            .then((response) => {
                return response.json();
            })
            .then(payload => {
                this.setState({settings:payload, isSettingsFetched: true});
            });
    }


    render() {
        let list = '';
        if(this.state.isSettingsFetched) {
            list =  this.state.settings.preferences.song_banned.map(element => {
               return <ConfigBannedItem id={element}  key={element}/>
            });
        }
        

        return(
            <Aux>
            <p className={Classes.SectionOpenPbScreen}>&nbsp;&nbsp;&nbsp;&nbsp; <a href="/config-bar" className={Classes.NoDecoration}> <i class="fas fa-chevron-circle-left"></i> Back</a> &nbsp;&nbsp;&nbsp;&nbsp; <a href="/mg-screen" target="_blank"  className={Classes.NoDecoration}> <i className="fas fa-home"></i> Back to Home</a> </p>
            <br/><br/>
            <div className="container">
                {/** MORAMMA AMBIENT */}
                <div className="row">
                    <div className="col-10 offset-1">
                        <div className={Classes.CardContainer}>
                        <br/>
                        <div className="row">
                                    <h4>Banned Songs:</h4>
                                    {list}      
                        </div> 
                            <br/>
                            <hr>
                            </hr>
                           {/** <div className="row">
                                <div className={"col-6 "}>
                                    <p>Banned Song</p>
                                </div>
                                <div className={"col-4 align-self-center" + Classes.TxtCenter}>
                                    <p>1</p>
                                </div>
                                <div className={"col-2 " + Classes.TxtCenter}>
                                    <img src={require('./../../assets/svg/right-arrow.svg')} alt="img configurazione" className={`${Classes.CardContainerIcon} ${Classes.bntActive}`} />
                                </div>
                            </div> 
                            <hr>
                            </hr> */}
                    </div>
                </div>
                <br/>
                <br/>
                </div>
            </div>
        </Aux>
        )
    }
}

export default ConfigBanned;